import { EmbeddedPdf } from "./EmbeddedPdf";

export const TermsOfService = () => {
  return <EmbeddedPdf pdfType="tos" />;
};
